/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CabinClassCriteriaDto,
    CabinClassCriteriaDtoFromJSON,
    CabinClassCriteriaDtoFromJSONTyped,
    CabinClassCriteriaDtoToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    PassengerAgeRange,
    PassengerAgeRangeFromJSON,
    PassengerAgeRangeFromJSONTyped,
    PassengerAgeRangeToJSON,
    PriceBand,
    PriceBandFromJSON,
    PriceBandFromJSONTyped,
    PriceBandToJSON,
    RuleFormDataAgencyOrGroup,
    RuleFormDataAgencyOrGroupFromJSON,
    RuleFormDataAgencyOrGroupFromJSONTyped,
    RuleFormDataAgencyOrGroupToJSON,
    SearchTravelRange,
    SearchTravelRangeFromJSON,
    SearchTravelRangeFromJSONTyped,
    SearchTravelRangeToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarkupV2FormData
 */
export interface MarkupV2FormData {
    /**
     * 
     * @type {string}
     * @memberof MarkupV2FormData
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupV2FormData
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupV2FormData
     */
    comment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2FormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {object}
     * @memberof MarkupV2FormData
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MarkupV2FormData
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupV2FormData
     */
    relevance?: number;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof MarkupV2FormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkupV2FormData
     */
    accountCodes?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2FormData
     */
    excludeAccountCodes?: boolean;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof MarkupV2FormData
     */
    distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<RuleFormDataAgencyOrGroup>}
     * @memberof MarkupV2FormData
     */
    agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof MarkupV2FormData
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<CabinClassCriteriaDto>}
     * @memberof MarkupV2FormData
     */
    cabinClasses?: Array<CabinClassCriteriaDto> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof MarkupV2FormData
     */
    salesJourneys?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkupV2FormData
     */
    bookingClasses?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2FormData
     */
    excludeBookingClasses?: boolean;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof MarkupV2FormData
     */
    providers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof MarkupV2FormData
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof MarkupV2FormData
     */
    markupType?: CodeAndLabel;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof MarkupV2FormData
     */
    marketingCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2FormData
     */
    carriersExclude?: boolean;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof MarkupV2FormData
     */
    dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof MarkupV2FormData
     */
    dateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {Array<SearchTravelRange>}
     * @memberof MarkupV2FormData
     */
    travelDates?: Array<SearchTravelRange> | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupV2FormData
     */
    cloneSourceId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2FormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MarkupV2FormData
     */
    markupAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MarkupV2FormData
     */
    markupPercentage?: number;
    /**
     * 
     * @type {Array<PriceBand>}
     * @memberof MarkupV2FormData
     */
    priceBands?: Array<PriceBand> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkupV2FormData
     */
    fareBasisCodes?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2FormData
     */
    fareBasisCodesExclude?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkupV2FormData
     */
    marketingFlightNumbers?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2FormData
     */
    marketingFlightNumbersExclude?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MarkupV2FormData
     */
    ticketDesignators?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2FormData
     */
    ticketDesignatorsExclude?: boolean | null;
    /**
     * 
     * @type {Array<PassengerAgeRange>}
     * @memberof MarkupV2FormData
     */
    passengerAges?: Array<PassengerAgeRange> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupV2FormData
     */
    basis?: boolean;
}

export function MarkupV2FormDataFromJSON(json: any): MarkupV2FormData {
    return MarkupV2FormDataFromJSONTyped(json, false);
}

export function MarkupV2FormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupV2FormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : json['accountCodes'],
        'excludeAccountCodes': !exists(json, 'excludeAccountCodes') ? undefined : json['excludeAccountCodes'],
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'agenciesAndGroups': !exists(json, 'agenciesAndGroups') ? undefined : (json['agenciesAndGroups'] === null ? null : (json['agenciesAndGroups'] as Array<any>).map(RuleFormDataAgencyOrGroupFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CabinClassCriteriaDtoFromJSON)),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : (json['salesJourneys'] === null ? null : (json['salesJourneys'] as Array<any>).map(CodeAndLabelFromJSON)),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : json['bookingClasses'],
        'excludeBookingClasses': !exists(json, 'excludeBookingClasses') ? undefined : json['excludeBookingClasses'],
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'markupType': !exists(json, 'markupType') ? undefined : CodeAndLabelFromJSON(json['markupType']),
        'marketingCarriers': !exists(json, 'marketingCarriers') ? undefined : (json['marketingCarriers'] === null ? null : (json['marketingCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'carriersExclude': !exists(json, 'carriersExclude') ? undefined : json['carriersExclude'],
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['dateTimeRestrictionsTimeZone']),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(SearchTravelRangeFromJSON)),
        'cloneSourceId': !exists(json, 'cloneSourceId') ? undefined : json['cloneSourceId'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'markupAmount': !exists(json, 'markupAmount') ? undefined : json['markupAmount'],
        'markupPercentage': !exists(json, 'markupPercentage') ? undefined : json['markupPercentage'],
        'priceBands': !exists(json, 'priceBands') ? undefined : (json['priceBands'] === null ? null : (json['priceBands'] as Array<any>).map(PriceBandFromJSON)),
        'fareBasisCodes': !exists(json, 'fareBasisCodes') ? undefined : json['fareBasisCodes'],
        'fareBasisCodesExclude': !exists(json, 'fareBasisCodesExclude') ? undefined : json['fareBasisCodesExclude'],
        'marketingFlightNumbers': !exists(json, 'marketingFlightNumbers') ? undefined : json['marketingFlightNumbers'],
        'marketingFlightNumbersExclude': !exists(json, 'marketingFlightNumbersExclude') ? undefined : json['marketingFlightNumbersExclude'],
        'ticketDesignators': !exists(json, 'ticketDesignators') ? undefined : json['ticketDesignators'],
        'ticketDesignatorsExclude': !exists(json, 'ticketDesignatorsExclude') ? undefined : json['ticketDesignatorsExclude'],
        'passengerAges': !exists(json, 'passengerAges') ? undefined : (json['passengerAges'] === null ? null : (json['passengerAges'] as Array<any>).map(PassengerAgeRangeFromJSON)),
        'basis': !exists(json, 'basis') ? undefined : json['basis'],
    };
}

export function MarkupV2FormDataToJSON(value?: MarkupV2FormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'description': value.description,
        'comment': value.comment,
        'disabled': value.disabled,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'relevance': value.relevance,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'accountCodes': value.accountCodes,
        'excludeAccountCodes': value.excludeAccountCodes,
        'distributionChannels': value.distributionChannels === undefined ? undefined : (value.distributionChannels === null ? null : (value.distributionChannels as Array<any>).map(Int32IdAndLabelToJSON)),
        'agenciesAndGroups': value.agenciesAndGroups === undefined ? undefined : (value.agenciesAndGroups === null ? null : (value.agenciesAndGroups as Array<any>).map(RuleFormDataAgencyOrGroupToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'cabinClasses': value.cabinClasses === undefined ? undefined : (value.cabinClasses === null ? null : (value.cabinClasses as Array<any>).map(CabinClassCriteriaDtoToJSON)),
        'salesJourneys': value.salesJourneys === undefined ? undefined : (value.salesJourneys === null ? null : (value.salesJourneys as Array<any>).map(CodeAndLabelToJSON)),
        'bookingClasses': value.bookingClasses,
        'excludeBookingClasses': value.excludeBookingClasses,
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'markupType': CodeAndLabelToJSON(value.markupType),
        'marketingCarriers': value.marketingCarriers === undefined ? undefined : (value.marketingCarriers === null ? null : (value.marketingCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'carriersExclude': value.carriersExclude,
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'dateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.dateTimeRestrictionsTimeZone),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(SearchTravelRangeToJSON)),
        'cloneSourceId': value.cloneSourceId,
        'allowEdit': value.allowEdit,
        'markupAmount': value.markupAmount,
        'markupPercentage': value.markupPercentage,
        'priceBands': value.priceBands === undefined ? undefined : (value.priceBands === null ? null : (value.priceBands as Array<any>).map(PriceBandToJSON)),
        'fareBasisCodes': value.fareBasisCodes,
        'fareBasisCodesExclude': value.fareBasisCodesExclude,
        'marketingFlightNumbers': value.marketingFlightNumbers,
        'marketingFlightNumbersExclude': value.marketingFlightNumbersExclude,
        'ticketDesignators': value.ticketDesignators,
        'ticketDesignatorsExclude': value.ticketDesignatorsExclude,
        'passengerAges': value.passengerAges === undefined ? undefined : (value.passengerAges === null ? null : (value.passengerAges as Array<any>).map(PassengerAgeRangeToJSON)),
        'basis': value.basis,
    };
}


